<template>
  <div>
    <div class="flex flex-start item-center m_t60">
      <div class="title font-bold font-20 ">我的订阅</div>
    </div>

    <el-select
      v-model="subscribeId"
      filterable
      placeholder="请选择"
      @change="hanldeSelect"
    >
      <el-option
        v-for="item in enableData"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <div class="empty" v-if="enableData.length == 0">
      <div class="lack m_t30">
        <img
          style="margin: 30px auto;height: 100px;display: block;"
          src="@images/center/recom.png"
          alt
        />
        <div style="text-align: center; margin-top: 20px;">请先订阅！</div>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="item" :name="item" v-for="item in tabs" :key="item">
        <Table
          ref="inform"
          :tableData="subscribeData"
          :loading="loading"
          :format="format"
          :type="currentBtn"/>
        <div class="pagination">
          <Pagination
            :total="total"
            :pages="pages"
            :currentPageSize="size"
            :currentPage="current"
            @currentChange="handleCurrentChange"
          /></div
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Pagination from "@components/base/pagination/CenterPagination.vue";
import Table from "@/components/base/table/body/TableAll.vue";
import { enableList, getDataList } from "@/api/account";
export default {
  name: "SubscribeList",
  components: {
    Table,
    Pagination,
  },
  data() {
    return {
      pages: 0,
      total: 0,
      size: 10,
      current: 1,
      subscribeData: [],
      subscribeId: "",
      enableData: [],
      activeName: "first",
      tabs: [],
      loading: false,
      currentBtn: 0,
      format: {},
      btns: [
        {
          label: "政策办理",
          value: "declareData",
          total: 0,
          pages: 0,
          data: [],
          format: {
            title: "title",
            addressCodeName: "addressCodeName",
            departmentName: "departmentName",
            releaseDate: "gmtCreate",
            pageView: "pageView",
          },
          path: "/detail/apply",
        },
        {
          label: "无申请兑现",
          value: "enjoyWithoutData",
          total: 0,
          pages: 0,
          data: [],
          format: {
            title: "name",
            addressCodeName: "dicTranslate",
            departmentName: "dicTranslate",
            releaseDate: "releaseTime",
            pageView: "browseCount",
          },
        },
        {
          label: "政策库",
          value: "policyData",
          total: 0,
          pages: 0,
          data: [],
          format: {
            title: "title",
            addressCodeName: "addressName",
            departmentName: "departmentName",
            releaseDate: "releaseDate",
            pageView: "pageView",
          },
          path: "/pcm/policyDetail",
        },
        {
          label: "政策解读",
          value: "policyUnscrambleData",
          total: 0,
          pages: 0,
          data: [],
          format: {
            title: "title",
            addressCodeName: "addressName",
            departmentName: "departmentName",
            releaseDate: "releaseDate",
            pageView: "pageView",
          },
          path: "/detail/text",
        },
        {
          label: "公示公告",
          value: "policyData",
          total: 0,
          pages: 0,
          data: [],
          format: {
            title: "title",
            addressCodeName: "addressName",
            departmentName: "departmentName",
            releaseDate: "releaseDate",
            pageView: "pageView",
          },
          path: "/pcm/policyDetail",
        },
      ],
      type: "",
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      enableList().then((res) => {
        if (res.data.result && res.data.result.length > 0) {
          this.enableData = res.data.result;
          if (res.data.result[0].columnIds) {
            this.tabs = res.data.result[0].columnIds.split(",");
            this.activeName = this.tabs[0];
            this.currentBtn = this.btns.findIndex((item, index) => {
              return item.label == this.tabs[0];
            });
            this.subscribeId = res.data.result[0].id;
            this.format = this.btns[this.currentBtn].format;
            this.getData();
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getData();
    },
    getData() {
      const options = {
        pageNumber: this.current,
        pageSize: this.size,
        type: this.activeName,
        id: this.subscribeId,
      };
      getDataList(options).then((res) => {
        const { code, result, msg } = res.data;
        if (code === 200 && result && result.records) {
          let { records, total, pages } = result;
          this.total = total;
          this.pages = pages;
          this.subscribeData = records;
          console.log(this.subscribeData, 8888);
        } else if (code === 200 && result && result.content) {
          let { content, totalElements, totalPages } = result;
          this.total = totalElements;
          this.pages = totalPages;
          this.subscribeData = content.map((item) => item.content);
        }
      });
    },
    handleClick() {
      this.currentBtn = this.btns.findIndex((item, index) => {
        return item.label == this.activeName;
      });
      this.format = this.btns[this.currentBtn].format;
      this.getData();
    },
    transText() {
      switch (this.type) {
        case 0:
          {
            this.$router.push({
              path: `/detail/apply`,
              query: {
                projectId: item.declareItemId,
                directionId: item.id,
              },
            });
          }
          break;
        case 1:
          {
            this.$router.push({
              path: `/pcm/noApply`,
            });
          }
          break;
        case 2:
          {
            this.$router.push({
              path: `/pcm/policyDetail`,
              query: {
                publicyId: item.id,
              },
            });
          }
          break;
        case 3:
          {
            this.$router.push({
              path: `/detail/text`,
              query: { textId: item.id },
            });
          }
          break;
        default:
          {
            return this.$message.warning("未匹配到相应政策详情");
          }
          break;
      }
    },
    hanldeSelect(val) {
      let currentItem = this.enableData.filter((item) => item.id == val);
      if (currentItem && currentItem.length > 0) {
        this.tabs = currentItem[0].columnIds.split(",");
        this.activeName = this.tabs[0];
      }
      this.currentBtn = this.btns.findIndex((item, index) => {
        return item.label == this.tabs[0];
      });
      this.subscribeId = currentItem[0].id;
      this.format = this.btns[this.currentBtn].format;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.inform {
  padding-bottom: 60px;
  border-bottom: 1px dotted rgba(169, 169, 169, 1);
}
::v-deep .el-select {
  width: 260px;
  margin: 35px 0px;
}
.direction {
  /deep/.el-button {
    border-radius: 10px;
    border: 1px solid #7d99fd;
    color: #7d99fd;
    background: rgba(125, 153, 253, 0.3);
    font-size: 20px;
    font-weight: bold;
    padding: 10px 20px;
  }

  .btn {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: #999;
    color: $white;
    text-align: center;
    font-size: 18px;
    border-radius: 5px;

    &.active {
      background: $blue;
      color: $white;
    }
  }
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .total_page {
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    margin-right: 10px;
  }
}
</style>
